import * as React from 'react'
function SvgSignCheck(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10 16v4H8v12h24V20h-4v-4h6c1.2 0 2 .8 2 2v16c0 1.2-.8 2-2 2H6c-1.2 0-2-.8-2-2V18c0-1.2.8-2 2-2h4zm16 8a2 2 0 110 4H14a2 2 0 110-4h12zM24.6 4.6c.8-.8 2-.8 2.8 0l2 2c.8.8.8 2 0 2.8l-10 10c-.4.4-.8.6-1.4.6h-4v-4c0-.6.2-1 .6-1.4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgSignCheck
